import { Bug, Droplets, FlaskConical, Gauge, Package, Shield, ShieldCheck } from 'lucide-react';
import { NavTabs, type NavTabItem } from '../ui/Tabs';
import { useModuleLicense } from '../../hooks/useModuleLicense';

/**
 * The spray module's section menu, on every top-level spray page. It used to
 * live on the dashboard alone, so reaching Inventory from the Chemical Registry
 * meant going back through Applications — and My Credentials was linked from
 * nowhere at all.
 */
export default function SprayNav() {
  const isSprayAdmin = useModuleLicense('spray', 'admin').hasAccess;

  const items: NavTabItem[] = [
    { to: '/spray', label: 'Applications', icon: <Droplets className="h-4 w-4" />, end: true },
    { to: '/spray/chemicals', label: 'Chemicals', icon: <FlaskConical className="h-4 w-4" /> },
    { to: '/spray/inventory', label: 'Inventory', icon: <Package className="h-4 w-4" /> },
    { to: '/spray/pests', label: 'Pests & Diseases', icon: <Bug className="h-4 w-4" /> },
    { to: '/spray/calibration', label: 'Calibration', icon: <Gauge className="h-4 w-4" /> },
    { to: '/spray/credentials/me', label: 'My Credentials', icon: <ShieldCheck className="h-4 w-4" /> },
  ];
  if (isSprayAdmin) {
    items.push({ to: '/spray/admin', label: 'Admin', icon: <Shield className="h-4 w-4" /> });
  }

  // A full-width strip under the header, on the header's own container, so the
  // bar does not change width as pages with different content widths swap in.
  return (
    <div className="border-b border-neutral-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <NavTabs label="Spray" items={items} className="shadow-none" />
      </div>
    </div>
  );
}
